import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Pause, Play } from "lucide-react";
import { heroSlides } from "../mock";

const HeroCarousel = ({ onCtaClick }) => {
  const [idx, setIdx] = useState(0);
  const [playing, setPlaying] = useState(true);

  useEffect(() => {
    if (!playing) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % heroSlides.length), 6000);
    return () => clearInterval(t);
  }, [playing]);

  const go = (dir) => setIdx((i) => (i + dir + heroSlides.length) % heroSlides.length);
  const slide = heroSlides[idx];

  return (
    <section className="relative w-full bg-[color:var(--brand-cream)]">
      <div className="relative h-[380px] md:h-[520px] lg:h-[580px] overflow-hidden">
        {heroSlides.map((s, i) => (
          <div
            key={s.id}
            className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${i === idx ? "opacity-100" : "opacity-0"}`}
          >
            <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/10 to-transparent" />
          </div>
        ))}

        <div className="relative h-full flex items-center px-6 md:px-16 lg:px-24">
          <div key={slide.id} className="max-w-xl fade-slide text-white">
            <div className="text-xs md:text-sm tracking-[0.3em] uppercase mb-3 text-white/90">
              {slide.eyebrow}
            </div>
            <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl leading-tight mb-4">
              {slide.title}
            </h1>
            <p className="text-sm md:text-base text-white/90 mb-6 max-w-md">
              {slide.subtitle}
            </p>
            <button onClick={onCtaClick} className="inline-block bg-white text-[color:var(--brand-ink)] px-8 py-3 text-sm font-semibold uppercase tracking-wider hover:bg-[color:var(--brand-red)] hover:text-white transition-colors">
              {slide.cta}
            </button>
          </div>
        </div>

        <button
          onClick={() => go(-1)}
          aria-label="Previous"
          className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 hover:bg-white text-neutral-800 flex items-center justify-center transition"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <button
          onClick={() => go(1)}
          aria-label="Next"
          className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 hover:bg-white text-neutral-800 flex items-center justify-center transition"
        >
          <ChevronRight className="w-5 h-5" />
        </button>

        <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-3">
          {heroSlides.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              className={`h-1.5 rounded-full transition-all ${i === idx ? "w-8 bg-white" : "w-2 bg-white/50"}`}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
          <button
            onClick={() => setPlaying((p) => !p)}
            className="ml-2 text-white/90 hover:text-white"
            aria-label={playing ? "Pause" : "Play"}
          >
            {playing ? <Pause className="w-3.5 h-3.5" /> : <Play className="w-3.5 h-3.5" />}
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroCarousel;
